<template>
    <v-select
      :id="'select-' + field_idx"
      v-if="field.values"
      label="label"
      :options="valideOptions"
      v-model="current_value"
      @input="updateFromSelect($event)"
      :classList="['select-'+field_idx]"
      class="v-select-select"
      :multiple="field.multiple"
      :placeholder="field.placeholder"
      :disabled="field.disabled"
      :value="full_value_of(current_value)"
    >
      <span slot="no-options">Saisissez au moins 3 caractères</span>
      <template slot="option" slot-scope="option">{{ option.label }}</template>
      <template slot="selected-option" slot-scope="option">{{ option.label }}</template>
    </v-select>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name:"CustomSelect",
  props:["field", "value","dropdownParent","field_idx","opt"],
  components:{
    vSelect
  },
  data() {
    return {
      current_value: null,
    }
  },

  mounted() {
        this.current_value = this.full_value_of(this.value)
  },

  methods:{
    updateFromSelect(event) {
      if (!this.opt)
        $('.clear').remove() // Remove the clear span
      let data = {
        type:this.field.type,
        idx:this.field_idx,
        new_value:(this.current_value ? (typeof(this.current_value) == typeof([]) ? this.current_value : this.current_value.value) : null)
      }
      this.$emit("field-updated", data)
    },

    full_value_of(label)
    {
      let res = null
      let found = []
      if (!this.field.multiple)
        {
          found = _.find(this.valideOptions, v => {
            return v == label || v.value == label
          })
          return res = found == undefined || found == null ? null : found
        }
      else {
        found = _.filter(this.valideOptions, v => {
            if (!_.isNil(label)) {
              return label.indexOf(v) != -1 || label.indexOf(v.value) != -1
            }
          })
        return found
      }
    }
  },
  computed:{
    valideOptions()
    {
      return _.map(this.field.values, (opt) => {
        return {
          label: opt.name ? opt.name : (opt.text ? opt.text : ""),
          value: opt.id
        }
      })
    }
  },
  watch:{
    value(oldValue, newValue) {
        this.current_value = this.full_value_of(this.value)
    }
  }
}
</script>

<style lang="scss">

.v-select {
    font-family: titillium, sans-serif;
    border-radius: 2px;
    border-color:rgba(0, 0, 0, 0.07);
    .dropdown-menu {
        width: auto;
    }
    a {
        opacity: 1 !important;
    }
}
.dropdown-menu > .highlight > a {
  /* .v-select .dropdown-menu >
   * required to override bootstrap 3's
   * .dropdown-menu > li > a:hover {} styles
   */
  background:#e7e7e7 !important;
  color: #333 !important;
}

div.dropdown-toggle  {
  border-radius: 2px !important;
  border-color:rgba(0, 0, 0, 0.07) !important;
}

span.selected-tag {
  background-color: white !important;
}

.v-select .open-indicator:before {
    /* border-color: rgba(60,60,60,.5); */
    border-style: solid;
    border-width: 3px 3px 0 0;
    content: "";
    height: 10px;
    vertical-align: top;
    transform: rotate(133deg);
    box-sizing: inherit;
}
// .v-select .dropdown-toggle .clear { visibility: hidden; }
</style>



// WEBPACK FOOTER //
// client/components/Forms/Elements/Select.vue